import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { STORE_PROMOTION_SETTINGS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getStorePromotionSettingsAction = createAsyncThunk(
    'price/getStorePromotionSettingsAction',
    async (type, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ STORE_PROMOTION_SETTINGS_PATH }/${ type }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getStorePromotionSettingsSlice = createSlice({
    name: 'getStorePromotionSettingsSlice',
    initialState: DEFAULT_STATE,
    extraReducers: builder => {
        builder.addCase(getStorePromotionSettingsAction.pending, () => STATE__API__STARTED);
        builder.addCase(getStorePromotionSettingsAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getStorePromotionSettingsAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getStorePromotionSettingsState = (state) => state.price.getStorePromotionSettings;
export default getStorePromotionSettingsSlice.reducer;